import { Backdrop, CircularProgress, Container, Grid, IconButton } from '@material-ui/core';
import { BackspaceOutlined as BackspaceOutlinedIcon, Delete as DeleteIcon } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useFieldArray, useForm } from "react-hook-form";
import Select from "../../components/Form/Select";
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { ConciergeSearch } from '../../interfaces/Concierge';
import { Supplier } from '../../interfaces/Supplier';
import ConciergeApi from '../../services/MvmApi';
import SupplierApi from '../../services/SupplierApi';
import { useStyles } from './Style';
import MvmApi from '../../services/MvmApi';

interface IFormInput {
    text:string;
    mascara:string;
    data:string;
    autocomplete:any;
    autocompletesearch:any;
    autocompletemulti:any;
    checkbox: boolean;
    item:string;
    lista1:any;
    conciergeCode: any;
}

const options = [
    { label: 'Opção 1', code: 1 },
    { label: 'Opção 2', code: 2 },
    { label: 'Opção 3', code: 3 },
    { label: 'Opção 4', code: 4 },
    { label: 'Opção 5', code: 5 },
    { label: 'Opção 6', code: 6 },
]
const Teste: React.FC = () => {
    const [lista, setLista] = useState<any>([{ label: 'Item 1' }])
    const { user } = useAuth();
    const classes = useStyles();
    const [concierges, setConcierges] = useState<any>([]);
    const refFieldText = useRef<HTMLElement>(null)
    const [circularLoading, setCircularLoading] = useState(false);

    const { handleSubmit, control, getValues, setValue } = useForm<IFormInput>(
        {
            defaultValues: { 
                conciergeCode: {code: '', label: ''},
                item: '', text: 'andgreg', mascara: '', data: '',  autocomplete: {}, 
            autocompletesearch: {code: '', label: ''}, autocompletemulti: [{ label: 'Opção 1', code: 1 }], checkbox: false, lista1: [{ label: 'Item 1' }] }
        });

    const { append, remove } = useFieldArray({
        control,
        name: "lista1",
    });

    useEffect(() => {
        foco()
    }, []); 

    function foco() {
        refFieldText.current?.focus();
    }
    const sendClick = async () => {
   
        setCircularLoading(true);
        await MvmApi.sendMvmClick()
            .then((result) => {
                alert('Fim de Envio');
            })
            .finally(() => {
                setCircularLoading(false);
            });
    }
    const sendSAP = async () => {
   
        setCircularLoading(true);
        await MvmApi.sendRequestInvoiceSAP()
            .then((result) => {
                alert('Fim de Envio');
            })
            .finally(() => {
                setCircularLoading(false);
            });
    }
    function remover(id: string, index: number) {
        setLista(lista.filter((it: any) => it.label !== id));
        remove(index);
    }

    const handleSearchSupplier = async(val: any) => {
        return await SupplierApi.search(val, user.company.plantID, "", 10)
        .then(result => {
          return result.items.map((supplier: Supplier) => { return { label: supplier.fullNameCnpj, value: supplier.supplierID, name: supplier.name, cnpj: supplier.cnpj } });
         });
    }
    useEffect(() => {

        let conciergeFilter:ConciergeSearch = {
            id:0,
            code: "",
            plantId: +user.company.plantID,
            deleted: false,
            pageSize: 999
        };

        ConciergeApi.searchConcierge(conciergeFilter)
        .then(result => {
            if (result && result.items) {
                setConcierges(result.items);}
            else {
                setConcierges([]);
            }
        }).catch(() => {
            setConcierges([]);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    setValue('conciergeCode', {code: "01", label: "01"});

    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={"Pagina de Testes de Componentes"} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <form onSubmit={handleSubmit(() => {})}>
                    <Backdrop
                                style={{ zIndex: 9999 }}
                                open={circularLoading}
                    >
                                <CircularProgress color="inherit" />
                    </Backdrop>                        
                        <Grid container spacing={1}>                        
                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'left' }}>
                                <ButtonUI onClick={() => sendClick() } startIcon={<BackspaceOutlinedIcon />}>{"Enviar para o Click"}</ButtonUI>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>                        
                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'left' }}>
                                <ButtonUI onClick={() => sendSAP() } startIcon={<BackspaceOutlinedIcon />}>{"Enviar para NF para SAP"}</ButtonUI>
                            </Grid>

                            
                            <Select 
                                    label={"AutocompleteSearch"} 
                                    name="autocompletesearch"
                                    control={control} 
                                    options={options}
                                    style={{width: '100%'}}
                                    searchFunction={handleSearchSupplier}
                                />

                        </Grid>                        

                            {/* <Grid container spacing={1}>
                                
                                <Grid item xs={6} style={{ padding: "0px", textAlign: 'left' }}>
                                    
                                    <Select
                                        freeSolo
                                        label="Portaria de Enatrada"
                                        name={'conciergeCode'}
                                        control={control} 
                                        style={{width: '100%'}}
                                        options={list}
                                        allowSelectValueNotFound={false}
                                        fullwidth
                                    />
                                    
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField label={"texto"} name="conciergeCode" control={control} fullWidth/>                                
                                </Grid>
                            </Grid> */}

                        {/* <Grid container spacing={1}>
                            
                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'left' }}>
                                <ButtonUI onClick={() => reset() } startIcon={<BackspaceOutlinedIcon />}>{"Limpar"}</ButtonUI>
                                <ButtonUI onClick={() => foco() } startIcon={<BackspaceOutlinedIcon />}>{"Foco"}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<CheckIcon />}>{"Submit"}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>
                            <Grid item xs={1}>
                                <TextField label={"texto"} name="text" control={control} inputRef={refFieldText} fullWidth/>                                
                            </Grid>
                            <Grid item xs={1}>
                                <TextField onChange={functionteste} label={"Mascara"} name="mascara" control={control} mask="99:99" fullWidth/>                                
                            </Grid>
                            <Grid item xs={1}>
                                <TextField label={"Data"} name="data" control={control} type="date"  InputLabelProps={{shrink:true}} fullWidth/>
                                <Date label={"Data"} name="data" control={control} type="date"  InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>                            
                            <Grid item xs={2}>
                                <Select
                                    label={"Autocomplete"} 
                                    name="autocomplete" 
                                    control={control} 
                                    options={options}
                                    setHelperValue={onChangeSelectShed}
                                    style={{width: '100%'}}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Autocomplete 
                                    multiple={true}
                                    filterSelectedOptions
                                    options={options}
                                    getOptionLabel={(option: any) => option.label}
                                    defaultValue={[{ label: 'Opção 1', code: 1 }]}
                                    style={{width: '100%'}}
                                    renderInput={(params) => (
                                        <TextInput {...params} label="Multiple"/>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Select 
                                    label={"AutocompleteSearch"} 
                                    name="autocompletesearch"
                                    control={control} 
                                    options={options}
                                    style={{width: '100%'}}
                                    searchFunction={handleSearchSupplier}
                                />
                            </Grid>

                            <Grid item xs={2} style={{marginLeft: '10px', marginTop: '10px'}}>
                                <CheckBox inputRef={refFieldCheckBox} label={"Checkbox"} name="checkbox" control={control}/>                                
                            </Grid>                            
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <TextField label={"texto"} name="item" control={control} fullWidth/>                                
                            </Grid>
                            <Grid item xs={2}>
                                <ButtonUI onClick={() => adicionar() } color="primary" startIcon={<CheckIcon />}>{"Adicionar"}</ButtonUI>
                            </Grid>
                        </Grid>

                        <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={lista}
                                    columns={columns} 
                                       
                                    options={{
                                        ...options,
                                        serverSide: false,
                                        pagination: options ? true : false,
                                        sort: options ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                    }}
                                />
                            </MuiThemeProvider> */}

                    </form>
                    {/* <h3>Submit value: {JSON.stringify(submitData)}</h3> */}
                </div>
            </div>
        </Container>
    )
}
export default Teste;
